'use client';

import { c as _c } from "react/compiler-runtime";
import { updateCoupon } from '@svenskaspelab/poolbetting/core/action/coupon';
import { useCoupon, useCouponId, useCouponIndices, useCouponType } from '@svenskaspelab/poolbetting/core/nextjs/coupon';
import { CouponAdditionsBetAmount } from '@svenskaspelab/poolbetting/ui/CouponAdditions';
import { debounce } from 'lodash';
import { type ReactNode, useCallback, useMemo, useState } from 'react';
type BetAmountContainerProps = {
  maxBetAmount: number;
  betAmounts: readonly number[];
  minBetAmount: number;
};

/**
 * Component responsible for rendering the betAmountSelector form. It validates and updates the state.
 *
 * @param root0 props
 * @param root0.minBetAmount Minimum bet amount
 * @param root0.maxBetAmount Maximum bet amount
 * @param root0.betAmounts Array of bet amounts
 * @returns component that renders the betAmountSelector
 */
export default function BetAmountContainer(t0) {
  const $ = _c(23);
  const {
    maxBetAmount,
    betAmounts,
    minBetAmount
  } = t0;
  const errorMessage = `Välj ett belopp mellan ${minBetAmount} och ${maxBetAmount} kr`;
  const [couponId, couponIndex] = useCouponId();
  let t1;
  if ($[0] !== couponId || $[1] !== couponIndex) {
    t1 = {
      couponId,
      couponIndex
    };
    $[0] = couponId;
    $[1] = couponIndex;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const couponType = useCouponType(t1);
  let t2;
  if ($[3] !== couponId) {
    t2 = {
      couponId
    };
    $[3] = couponId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const couponIndices = useCouponIndices(t2);
  let t3;
  if ($[5] !== couponId || $[6] !== couponIndex) {
    t3 = {
      couponId,
      couponIndex
    };
    $[5] = couponId;
    $[6] = couponIndex;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const model = useCoupon(t3);
  const [betAmountErrorMessage, setBetAmountErrorMessage] = useState("");
  let t4;
  if ($[8] !== errorMessage) {
    t4 = debounce(() => {
      setBetAmountErrorMessage(errorMessage);
    }, 500);
    $[8] = errorMessage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const debouncedError = t4;
  let t5;
  if ($[10] !== couponId || $[11] !== couponIndex || $[12] !== couponIndices || $[13] !== couponType || $[14] !== debouncedError || $[15] !== maxBetAmount || $[16] !== minBetAmount) {
    t5 = newBetAmount => {
      const isRangeOk = newBetAmount >= minBetAmount && newBetAmount <= maxBetAmount;
      if (isRangeOk) {
        setBetAmountErrorMessage("");
        if (couponType === "singlerows") {
          for (const index of couponIndices) {
            (async () => {
              await updateCoupon({
                betAmount: newBetAmount
              }, {
                couponId,
                couponIndex: index
              });
            })();
          }
        } else {
          (async () => {
            await updateCoupon({
              betAmount: newBetAmount
            }, {
              couponId,
              couponIndex
            });
          })();
        }
        debouncedError.cancel();
      } else {
        if (Number.isNaN(newBetAmount)) {
          return;
        } else {
          debouncedError();
        }
      }
    };
    $[10] = couponId;
    $[11] = couponIndex;
    $[12] = couponIndices;
    $[13] = couponType;
    $[14] = debouncedError;
    $[15] = maxBetAmount;
    $[16] = minBetAmount;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const handleBetAmountChanged = t5;
  if (!model) {
    return;
  }
  let t6;
  if ($[18] !== betAmountErrorMessage || $[19] !== betAmounts || $[20] !== handleBetAmountChanged || $[21] !== model.betAmount) {
    t6 = <CouponAdditionsBetAmount betAmounts={betAmounts} currentBetAmount={model.betAmount} onBetAmountChange={handleBetAmountChanged} errorMessage={betAmountErrorMessage} />;
    $[18] = betAmountErrorMessage;
    $[19] = betAmounts;
    $[20] = handleBetAmountChanged;
    $[21] = model.betAmount;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}